import { mountUserStrollers } from 'mk2/apps/blogs/miniapps';

// this code is based on /data/dev/web/js/apps/photoblog/photoblogApp/comment2.js

export function initStatic(conf) {
    const placeholder = conf.node;
    const key = "0";
    const isAdmin = conf.requestor_isAdmin;
    const username = conf.blog_username;
    const userId = conf.blog_userId;
    mountUserStrollers(placeholder, key, isAdmin, username, userId);
}
